import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { TextSubHeading, Link } from 'blocket-ui'
import Price from 'components/AdListItem/Price'
import ListImage from 'components/AdListItem/ListImage'

import { buildAdUrl } from 'utils/url'

export const Subject = styled(TextSubHeading)`
  margin-bottom: 4px;
`

const Wrapper = styled(Link)`
  display: block;
  border-bottom: 1px solid #efefef;
  padding: 16px 0 4px 0;
`

const ImageWrapper = styled.div`
  height: 163px;
`

const StyledContent = styled.div`
  padding: 8px 0;
`

export const GalleryItem = ({ ad }) => {
  const { subject, images = [] } = ad
  return (
    <Wrapper to={buildAdUrl(ad)}>
      <ImageWrapper>
        <ListImage image={images[0]} />
      </ImageWrapper>
      <StyledContent>
        <Subject>{subject}</Subject>
        <Price price={ad.price} />
      </StyledContent>
    </Wrapper>
  )
}

GalleryItem.propTypes = {
  ad: PropTypes.shape({
    adId: PropTypes.string.isRequired,
    subject: PropTypes.string.isRequired,
    shareUrl: PropTypes.string,
    partnerInfo: PropTypes.shape({
      name: PropTypes.string,
    }),
    price: PropTypes.shape({
      label: PropTypes.string.isRequired,
      suffix: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
    }),
    images: PropTypes.arrayOf(
      PropTypes.shape({
        url: PropTypes.string.isRequired,
        width: PropTypes.number,
        height: PropTypes.number,
      }),
    ),
  }),
}
